const mixins = {
  hoverCondition: (hover = 'hover', breakpoint = '1120px') => {
    return `@media (hover: ${hover}) and (min-width: ${breakpoint})`
  },
}

export default mixins
